export const isBrowser = () => typeof window === 'object';
